module.exports = __webpack_public_path__ + "static/media/calculator.65f8fec9.svg";